<script setup lang="ts">
import { toRefs } from 'vue';
import { formatDateTime } from '@services/utils/Formatters';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps<{
  paymentData: {
    id: number;
    flowOrder?: number | null;
    commerceOrder: number;
    amount: number;
    currency: string;
    status: string;
    payer: string;
    returnedAt?: string | null;
  };
}>();

const { paymentData } = toRefs(props);
</script>

<template>
  <p><strong>{{ t('operaciones.modal_content_payment.estado') }}:</strong> {{ paymentData.status }}</p>
  <p><strong>{{ t('operaciones.modal_content_payment.monto') }}:</strong> {{ paymentData.amount }} {{ paymentData.currency }}</p>
  <p><strong>{{ t('operaciones.modal_content_payment.pagador') }}:</strong> {{ paymentData.payer }}</p>
  <p><strong>{{ t('operaciones.modal_content_payment.orden_comercio') }}:</strong> {{ paymentData.commerceOrder }}</p>
  <p v-if="paymentData.flowOrder"><strong>{{ t('operaciones.modal_content_payment.flow_order') }}:</strong> {{ paymentData.flowOrder }}</p>
  <p v-if="paymentData.returnedAt"><strong>{{ t('operaciones.modal_content_payment.fecha_retorno') }}:</strong> {{ formatDateTime(paymentData.returnedAt) }}</p>
</template>
